<app-windowlist [model]="this">
    <div class="row">
        <div class="col-lg-2 pr-lg-0" *ngIf="filterbox">
            <div class="d-none d-lg-block w-100 text-center text-primary">Filtri</div>
            <app-filtercontainer [title]="'Filtra per date o sedi'">
                <app-filterdate [date_type]="mode!='embedded'?99:100" [class]="'card p-1'" [filter_date]="filter_date" (onSelect)="updateList()"></app-filterdate>
                <ng-container *ngIf="checkPermissions('showCreatedFrom') && isModuleEnabled('shops')">
                    <ul class="card small-box list-group p-1 my-2" *ngIf="shops && shops.length>1">
                        <li class="list-group-item text-truncate pointer" [class.active]="filter_created_from.value==''" (click)="filter_created_from.value='';updateList()">Tutte le sedi</li>
                        <li class="list-group-item text-truncate pointer" *ngFor="let s of shops" [class.active]="filter_created_from.value==s.id" (click)="filter_created_from.value=s.id;updateList()">{{s.name}}</li>
                        <div  *ngIf="shops.length>2" class="icon"><i class="fa fa-store-alt "></i></div>
                    </ul>
                </ng-container>
            </app-filtercontainer>
        </div>
        <div [class.col-lg-10]="filterbox" [class.col-lg-12]="!filterbox" >
            <div class="card elevation-0 border-0">
              <ng-container *ngIf="filterbox">
                    <app-filtercontainer [title]="'Altri filtri'">              
                        <div class="row">
                            <div class="col-sm-6 col-lg-2 pr-lg-0">
                                <div class="m-1">
                                    <select class="form-control form-control-sm" [(ngModel)]="filter_id_type.value" (ngModelChange)="updateList()" [class.alert-success]="filter_id_type.value==1" [class.alert-danger]="filter_id_type.value==2">
                                        <option value="">Entrate + Uscite</option>
                                        <option value="1">Solo Entrate</option>
                                        <option value="2">Solo Uscite</option>
                                    </select>
                                </div>
                            </div>                       
                            <div class="col-sm-6 col-lg-2 px-lg-0">
                                <div class="m-1">
                                    <select class="form-control form-control-sm" [(ngModel)]="filter_method_payment.value" (ngModelChange)="updateList()" [class.alert-info]="filter_method_payment.value">
                                        <option value="">Tutti i metodi di pagamento</option>
                                        <option *ngFor="let m of methodpayments" (value)="m.name">{{m.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-6 col-lg-2 px-lg-0">
                                <div class="m-1">
                                    <select class="form-control form-control-sm"  [(ngModel)]="filter_source.value" (ngModelChange)="updateList()" [class.alert-info]="filter_source.value">
                                        <option value="">Tutte le banche/casse</option>
                                        <option *ngFor="let s of sources" (value)="s.description">{{s.description}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-6 col-lg-2 px-lg-0" *ngIf="mode=='embedded'">
                                <div class="m-1">
                                    <select class="form-control form-control-sm" [(ngModel)]="modeShow" (ngModelChange)="updateList()" [class.alert-info]="modeShow!=0">
                                        <option [value]=0>Tutti i periodi</option>
                                        <option [value]=1>Anno in corso</option>
                                        <option [value]=2>Ultimi 365 giorni</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-6 col-lg-2 px-lg-0" [class.col-lg-3]="mode!='embedded'" *ngIf="checkPermissions('showFinancialAccount') && isModuleEnabled('financialaccounts') && financialaccounts.length>1">
                                <div class="m-1">
                                    <app-financialaccount [showAll]="true" [id_financialaccount]="this.filter_financialaccount.value" (selected)="this.filter_financialaccount.value=$event['id'];getItems()"></app-financialaccount>
                                </div>
                            </div>                          
                            <div class="col-sm-6 col-lg-2 pl-lg-0" [class.col-lg-3]="mode!='embedded'">
                                <div class="m-1">
                                    <div class="input-group input-group-sm">
                                         <div class="input-group-prepend">
                                            <button class="btn btn-xs border"  (click)="all_users==true?all_users=false:all_users=true">
                                                <i *ngIf="!all_users" class="fas fa-user" title="Visualizza solo operatori abilitati" ></i>
                                                <i *ngIf="all_users" class="fas fa-user-lock text-pink" title="Visualizza anche operatori disabilitati" ></i>
                                            </button>
                                        </div>
                                        <select class="form-control form-control-sm" [(ngModel)]="filter_id_user.value" (ngModelChange)="updateList()" [class.alert-info]="filter_id_user.value">
                                            <option value="">Tutti gli operatori</option>
                                            <ng-container *ngFor="let u of users">
                                                <ng-container *ngIf="all_users">
                                                    <option [class.text-orange]="!u.enabled" [ngValue]="u.id">{{u.name}}</option>
                                                </ng-container>
                                                <ng-container *ngIf="!all_users">
                                                    <option *ngIf="u.enabled" [ngValue]="u.id">{{u.name}}</option>
                                                </ng-container>
                                            </ng-container>
                                        </select>                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                    </app-filtercontainer>
                    <div class="row">
                        <div class="col-12 col-lg-9">
                            <div class="input-group input-group-sm m-1" >
                                <input type="text" #table_search name="table_search" class="form-control float-right"
                                    placeholder="cerca per causale, anagrafica o metodo di pagamento..."
                                    [(ngModel)]="filter_search.value" (keyup.enter)="updateList()" [class.alert-info]="filter_search.value!=''" [class.alert-info]="filter_search.value!=''">
                                <div class="input-group-append">
                                    <button type="submit" class="btn btn-default text-primary" title="Avvia ricerca" (click)="updateList()"><i class="fas fa-search"></i></button>
                                    <button class="btn btn-default text-danger" title="Annulla ricerca" *ngIf="filter_search.value!=''" (click)="filter_search.value='';updateList();"><span id="searchclear" class="fas fa-times"></span></button>
                                    <button class="btn btn-default" title="Ricerca avanzata" data-toggle="collapse" data-target="#advancedSearchPanel"  aria-expanded="false" aria-controls="advancedSearchPanel" ><span id="searchclear" class="fas fa-sliders-h"></span></button>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-3">
                            <app-windowlistbuttons 
                            [model]="this" 
                            [table]="'cashflow'" 
                            [openDetailExtra]="[{'name':'id_address','value':id_address},{'name':'id_table','value':id_table},{'name':'table','value':table},{'name':'reference','value':reference}]" 
                            [funs]="[
                                {'name':'Altri comandi','value':''},
                                {'name':'Riconciliazione bancaria','value':'XXXopenReconciliationModal'},
                                {'name':'Crea documento fiscale','value':'createDocument'},
                                {'name':'Assegna conto contabile','value':'assignFinancialAccount','role':'Admin','module':'financialaccounts'},
                            ]"
                            ></app-windowlistbuttons>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div  class="small-box card m-1 p-1 collapse" id="advancedSearchPanel">
                                <div class="row">
                                    <div class="col-12 col-lg-10">
                                        <app-advancedsearch [id_field]="'c.id'" [table]="'cashflow'" [filters]="advancedFilter"></app-advancedsearch>
                                    </div>
                                    <div class="col-12 col-lg-2 pl-1">
                                        <button title="Filtra" class="btn btn-default border btn-sm h-100 float-right" (click)="updateList()">
                                            <i class="fa fa-filter"></i><span class="ml-1 d-none d-lg-inline">Applica</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <div *ngIf="!list || list.length==0" class="m-5 text-center text-secondary">
                    <i class="far fa-meh mr-2"></i><i>{{messageStatus}}</i>
                </div>
                <form *ngIf="list && list.length>0" [formGroup]="form">
                    <table class="table table-striped table-nowrap table-sm m-0 text-sm">
                        <thead>
                            <th>
                                <div #checkboxselectall class="icheck-primary d-inline mr-3">
                                    <input type="checkbox" title="Seleziona tutti"
                                    (change)="onChangeAll($event.target.checked);calculateSelected(false,false)" />
                                </div>
                            </th>
                            <th>Data
                                <button type="button" class="btn btn-tool" (click)="switchOrdering('c.date')">
                                    <i class="fas fa-sort {{classOrdering('c.date')}}"  ></i>
                                </button>
                            </th>
                            <th>Causale
                                <button type="button" class="btn btn-tool" (click)="switchOrdering('c.description')">
                                    <i class="fas fa-sort {{classOrdering('c.description')}}"  ></i>
                                </button>
                            </th>
                            <th *ngIf="mode!='embedded'">Anagrafica</th>
                            <th class="text-center d-none d-xl-table-cell" title="Conti contabili" *ngIf="checkPermissions('showFinancialAccount') && isModuleEnabled('financialaccounts')">Conto</th>
                            <th class="text-center">Importo
                                <button type="button" class="btn btn-tool" (click)="switchOrdering('c.amount')">
                                    <i class="fas fa-sort {{classOrdering('c.amount')}}"  ></i>
                                </button>
                            </th>
                            <th class="text-center"  *ngIf="show_paid">Versato
                                <button type="button" class="btn btn-tool" (click)="switchOrdering('c.paid')">
                                    <i class="fas fa-sort {{classOrdering('c.paid')}}"  ></i>
                                </button>
                            </th>
                            <th class="text-center"  *ngIf="show_paid">Differenza
                                <button type="button" class="btn btn-tool" (click)="switchOrdering('c.paid')">
                                    <i class="fas fa-sort {{classOrdering('c.paid')}}" ></i>
                                </button>
                            </th>
                            <th class="text-center" *ngIf="!show_paid">Cassa</th>
                            <th *ngIf="showReference">
                                <!-- <i (click)="showReference=false;updateList()" title="Nascondi Riferimenti" class="fa text-danger fa-times mr-1 pointer"></i> -->
                                Riferimento
                            </th>
                            <th class="d-none d-xl-table-cell text-center">Operatore</th>
                            <th>
                                <button [class.bg-primary]="showReference==true" title="Mostra riferimenti" type="button" class="btn btn-xs btn-default border float-right" (click)="showReference==true?showReference=false:showReference=true;updateList()"><i class="fa fa-link"></i></button>
                            </th>
                        </thead>
                        <thead>
                            <tr>                                
                                <td colspan="3">
                                    <b>TOTALE</b>
                                </td>
                                <td *ngIf="mode!='embedded'"></td>
                                <td *ngIf="checkPermissions('showFinancialAccount') && isModuleEnabled('financialaccounts')" class="d-none d-xl-table-cell"></td>
                                <td class="text-center">
                                    <b>{{total_amount | currency:'EUR':true }}</b>
                                </td>                                
                                <td class="text-center" *ngIf="show_paid">
                                    <b>{{total_paid | currency:'EUR':true }}</b>
                                </td>
                                <td  class="text-center" *ngIf="show_paid">
                                    <b *ngIf="total_difference!=0">{{total_difference | currency:'EUR':true }}</b>
                                </td>                                
                                <td *ngIf="!show_paid"></td>
                                <td class="d-none d-xl-table-cell" *ngIf="showReference"></td>
                                <td class="d-none d-xl-table-cell"></td>
                                <td></td>
                            </tr>
                            <tr class="text-gray" *ngIf="total_amount_future!=total_amount">                                
                                <td colspan="3">
                                    <i>* <b>FUTURO</b> (valori ancora da contabilizzare)</i>
                                </td>
                                <td *ngIf="mode!='embedded'"></td>
                                <td *ngIf="checkPermissions('showFinancialAccount') && isModuleEnabled('financialaccounts')" class="d-none d-xl-table-cell"></td>
                                <td class="text-center">
                                    <i>{{total_amount_future | currency:'EUR':true}}</i>
                                </td>
                                <td class="text-center" *ngIf="show_paid">
                                    <i>{{total_paid_future | currency:'EUR':true}}</i>
                                </td>
                                <td class="text-center" *ngIf="show_paid">                                   
                                    <i *ngIf="total_difference_future!=0">{{total_difference_future | currency:'EUR':true}}</i>
                                </td>
                                <td *ngIf="!show_paid"></td>
                                <td class="d-none d-xl-table-cell" *ngIf="showReference"></td>
                                <td class="d-none d-xl-table-cell"></td>
                                <td></td>
                            </tr>
                            <tr class="text-primary" *ngIf="num_selected>1">                                
                                <td colspan="3">
                                   <i><b>SELEZIONATI</b> ({{num_selected}} elementi)</i>
                                </td>
                                <td *ngIf="mode!='embedded'"></td>
                                <td *ngIf="checkPermissions('showFinancialAccount') && isModuleEnabled('financialaccounts')" class="d-none d-xl-table-cell"></td>
                                <td class="text-center">
                                    <i>{{total_amount_selected | currency:'EUR':true}}</i>
                                </td>
                                <td class="text-center" *ngIf="show_paid">
                                    <i>{{total_paid_selected | currency:'EUR':true}}</i>
                                </td>
                                <td class="text-center" *ngIf="show_paid">
                                    <i *ngIf="total_difference_selected!=0">{{total_difference_selected | currency:'EUR':true}}</i>
                                </td>
                                <td *ngIf="!show_paid"></td>
                                <td class="d-none d-xl-table-cell" *ngIf="showReference"></td>
                                <td class="d-none d-xl-table-cell"></td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                        
                            <!-- elemento ripetuto -->
                            <ng-container *ngFor="let record of list">
                                <tr *ngIf="isShowed(record)" [class.bg-futureline]="verifyDate(record.date)" [class.bg-redline]="record.id_type==2" [class.bg-greenline]="record.id_type==1">
                                    <td  title="{{record.date | date:'EEEE'}}">
                                        <div class="icheck-primary d-inline mr-3">
                                            <input type="checkbox" #checkrecord id_record="{{record.id}}"  title="ID: {{record.id}}" 
                                            (change)="onChange(record.id, $event.target.checked);calculateSelected(record, $event.target.checked)" [checked]="checkedAll"
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <a [class.trashed]="record.status == 2" (click)="openDetail(record)">
                                            {{record.date | date:'dd/MM/yyyy'}}<br><small class="text-gray">{{record.date | date:'EEEE'}}</small>
                                        </a>
                                    </td>
                                    <td style="max-width:16rem">
                                        <b>{{record.description}}</b>
                                        <ng-container *ngIf="record.note!=undefined && record.note!=''">
                                            <br><small class="d-inline-block overflow-hidden w-100" style="max-height:1.7rem;" title="{{record.note}}">
                                                <i class="fas fa-thumbtack text-info mr-2"></i>{{record.note}}</small>
                                        </ng-container></td>
                                    <td *ngIf="mode!='embedded'">
                                        <i class="fas fa-user text-gray mr-1"></i>{{record.addressname}}
                                        <!-- <small *ngIf="checkPermissions('showFinancialAccount') && isModuleEnabled('financialaccounts')">
                                            <br><span class="badge border text-purple"><i class="fas fa-coins mr-1"></i><b>Conto {{record.id_financialaccounts}}</b></span>
                                        </small> -->
                                    </td>
                                    <td class="text-center d-none d-xl-table-cell" *ngIf="checkPermissions('showFinancialAccount') && isModuleEnabled('financialaccounts')">
                                        <div class="text-purple m-auto " (click)="record['editFinancial']=true" style="max-width:6rem" title="Selezione conto contabile">
                                            <small>
                                                <i class="fas fa-coins pointer" 
                                                    [class.fa-2x]="!record.financialaccountname" 
                                                    [class.text-gray]="!record.financialaccountname"></i><br>
                                                <span class="pointer">{{record.financialaccountname}}</span>
                                                <ng-container *ngIf="record['editFinancial']">
                                                    <app-financialaccount [id_financialaccount]="record.id_financialaccount" [showOnlyTree]="true" [financialaccount]="record.financialaccount" (selected)="updateFinancialAccount(record,$event);"></app-financialaccount>
                                                </ng-container>
                                            </small>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <span *ngIf="record.id_type==1" >{{ record.amount*(1+record.tax/100) | currency:'EUR':true }}<span *ngIf="verifyDate(record.date)">*</span></span>
                                        <span *ngIf="record.id_type==2" class="text-red">{{ record.amount*(1+record.tax/100)*-1 | currency:'EUR':true }}<span *ngIf="verifyDate(record.date)">*</span></span>
                                        <br/>
                                        <small><span *ngIf="record.method_payment" class="badge border"><b>{{record.method_payment}}</b></span></small>
                                        <ng-container *ngIf="show_paid">
                                            <br *ngIf="record.method_payment" />
                                            <div *ngIf="record.source" style="max-width:5rem" class="badge border text-truncate"><i class="fas fa-warehouse mr-1"></i><b>{{record.source}}</b></div>
                                        </ng-container>                                        
                                    </td>
                                    <td class="text-center" *ngIf="show_paid">
                                        <span *ngIf="record.id_type==1" >{{ record.paid | currency:'EUR':true }}<span *ngIf="verifyDate(record.date)">*</span></span>
                                        <span *ngIf="record.id_type==2" class="text-red">{{ record.paid*-1 | currency:'EUR':true }}<span *ngIf="verifyDate(record.date)">*</span></span>
                                    </td>
                                    <td class="text-center" *ngIf="show_paid">
                                        <span *ngIf="record.balance==0">--</span>
                                        <span *ngIf="record.balance!=0" [class.text-red]="record.balance < 0">{{ record.balance | currency:'EUR':true }}<span *ngIf="verifyDate(record.date)">*</span></span>
                                    </td>
                                    <td class="text-center" *ngIf="!show_paid" style="max-width:6rem">
                                        <div *ngIf="record.source" class="text-truncate">{{record.source}}</div>
                                    </td>
                                    <td class="d-none d-xl-table-cell py-1" *ngIf="showReference">
                                        <small>
                                            <app-reference *ngIf="record.reference" [table]="record.table" [reference]="record.reference"></app-reference>
                                        </small>
                                    </td>
                                    <td class="text-center text-gray d-none d-xl-table-cell" style="max-width:6rem">
                                        <div *ngIf="record.username" class="rounded-circle d-flex align-items-center justify-content-center bg-purple mx-auto text-uppercase" style="height:2rem; width:2rem" title="{{record.username}} ">{{record.username[0]}}</div>
                                    </td>
                                    <td>                                        
                                        <button type="button" *ngIf="mode=='modal'" class="btn btn-secondary btn-xs float-right" (click)="selectRecord(record);">
                                            <span class="d-none d-sm-inline-block m-1">Seleziona</span><i class="fas fa-chevron-right"></i></button>
                                        <button type="button" *ngIf="mode=='embedded'" class="btn btn-xs btn-default float-right " title="Scollega" (click)="unlink(record);">
                                            <i class="fa fa-times"></i></button>
                                        <button type="button" *ngIf="deleteInRow" class="btn btn-xs btn-danger float-right " title="Cestina" (click)="trash([record.id],true);">
                                            <i class="fa fa-trash-alt"></i></button>
                                        <button type="button" *ngIf="mode!='modal'" (click)="openDetail(record)" title="Modifica / Vedi" class="btn btn-secondary btn-xs float-right ">
                                            <i class="fas fa-pencil-alt"></i></button>
                                        <button type="button" *ngIf="mode!='modal'" (click)="duplicate(record)" title="Duplica" class="btn btn-info btn-xs float-right ">
                                            <i class="far fa-clone"></i></button>
                                       
                                    </td>
                                </tr>
                            </ng-container>
                            <!-- fine elemento ripetuto -->
                            
                        </tbody>
                        <tfoot>
                            <tr>                                
                                <td colspan="3">
                                    <b>TOTALE</b>
                                </td>
                                <td *ngIf="mode!='embedded'"></td>
                                <td *ngIf="checkPermissions('showFinancialAccount') && isModuleEnabled('financialaccounts')" class="d-none d-xl-table-cell"></td>
                                <td class="text-center">
                                    <b>{{total_amount | currency:'EUR':true }}</b>
                                </td>
                                <td class="text-center" *ngIf="show_paid" [class.text-red]="total_paid < 0">
                                    <b>{{total_paid | currency:'EUR':true }}</b>
                                </td>
                                <td class="text-center" *ngIf="show_paid" [class.text-red]="total_difference < 0">
                                    <b *ngIf="total_difference!=0">{{total_difference | currency:'EUR':true }}</b>
                                </td>
                                <td *ngIf="!show_paid"></td>
                                <td class="d-none d-xl-table-cell" *ngIf="showReference"></td>
                                <td class="d-none d-xl-table-cell"></td>
                                <td></td>
                            </tr>
                            <tr class="text-success">                                
                                <td colspan="3"><b>ENTRATE</b></td>
                                <td *ngIf="mode!='embedded'"></td>
                                <td *ngIf="checkPermissions('showFinancialAccount') && isModuleEnabled('financialaccounts')" class="d-none d-xl-table-cell"></td>
                                <td class="text-center">
                                    <b>{{total_amount_in | currency:'EUR':true }}</b>
                                </td>
                                <td class="text-center text-success" *ngIf="show_paid">
                                    <b>{{total_paid_in | currency:'EUR':true }}</b>                                    
                                </td>
                                <td></td>
                                <td class="d-none d-xl-table-cell" *ngIf="showReference"></td>
                                <td class="d-none d-xl-table-cell"></td>
                                <td></td>
                            </tr>
                            <tr class="text-danger">                                
                                <td colspan="3"><b>USCITE</b></td>
                                <td *ngIf="mode!='embedded'"></td>
                                <td *ngIf="checkPermissions('showFinancialAccount') && isModuleEnabled('financialaccounts')" class="d-none d-xl-table-cell"></td>
                                <td class="text-center">
                                    <b>{{total_amount_out | currency:'EUR':true }}</b>
                                </td>
                                <td class="text-center" *ngIf="show_paid">
                                    <b>{{total_paid_out | currency:'EUR':true }}</b>                                    
                                </td>
                                <td></td>
                                <td class="d-none d-xl-table-cell" *ngIf="showReference"></td>
                                <td class="d-none d-xl-table-cell"></td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </form>
                <div class="card-footer clearfix py-1" *ngIf="mode!='embedded'">
                    <app-pagination [model]="this" ></app-pagination>
                </div>
                 
            </div>
        </div>
    </div>
</app-windowlist>


<ng-template #reconciliationModel let-modal>
    <div class="modal-header">
        Riconciliazione bancaria
        <div class="card-tools">
            <button type="button" class="btn btn-tool" (click)="modal.close()" >
              <i class="fas fa-times"></i>
            </button>
        </div>
    </div>
    <div class="modal-body" style="overflow-y: auto;max-height: 400px;">
        <div class="row">
            <!-- <div class="col-12 my-2" *ngIf="message!=''">
                <div class="alert border-info text-info text-center">
                    <i class="fas fa-info-circle mr-2"></i>{{message}}
                </div>
            </div> -->

            <ng-container *ngIf="csv.length == 0">
                <div class="col-lg-9">           
                        <div class="m-auto w-100 text-center p-2" style="max-width: 600px; height:200px; color:#ccc; border: 1px dashed #ccc; border-radius:10px">
                            <i class="fas fa-2x fa-bullseye mt-5 animation__wobble"></i><br>
                            <i>Trascina e rilascia <b>qui</b> il file CSV da importare.</i><br>
                            <a class="btn btn-secondary btn-sm mt-4" (click)="onChange($event)"><i class="fas fa-upload mr-2"></i>Scegli...</a>
                        </div>
                        <input class="d-block w-100 pointer" type="file" style="max-width: 600px; height:200px; margin:-200px auto 0; opacity:0;" #fileToUpload name="fileToUpload" (change)="onChange($event)">
                    <div class="row">
                        <div class="col-12 col-lg-4"></div>
                        <div class="col-12 col-lg-4 mt-2">
                            <label>Carattere separatore</label>
                            <input type="text" size="1" class="form-control form-control-sm" [(ngModel)]="separator">
                        </div>
                    </div>           
            </div>
                <div class="col-lg-3 border-left text-xs">
                    <h6>Attenzione</h6>
                    <p>
                    Per importare correttamente il file CSV, è necessario che:<br>
                    - sia stato impostato il <b>carattere separatore</b> corretto (di solito la virgola o il punto e virgola)<br>
                    - le colonne <b>Nominativo</b> e <b>Data</b> siano sempre valorizzati (no NULL)<br>
                    - le date siano nel formato ISO (<b>YYYY-MM-DD</b>)<br>
                    - nei valori non ci siano caratteri come: <b>¶</b> (a capo) <b>"</b> (virgolette) <b>'</b> (apici) <b>{{separator}}</b> (carattere separatore)<br>
                    </p>
                </div>
            </ng-container>

            <!-- <ng-container *ngIf="csv.length > 0">         -->
                    <div class="col-3 text-right">
                        <label>Banca</label>
                    </div>
                     <div class="col-6">
                        <select class="form-control form-control-sm">
                            <option >Bancoposta</option>
                            <option >CREDEM</option>
                        </select>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="table-responsive" style="max-height: 300px; overflow: auto;">
                            <table class="table table-sm table-bordered">
                                <!-- <thead>
                                    <th></th>
                                    <th *ngFor="let col of headers">
                                        {{col.name}}
                                    </th>
                                </thead>
                                <thead>
                                    <th></th>
                                    <th *ngFor="let h of headers;let j=index">
                                        <select class="form-control form-control-sm" [(ngModel)]="h.field">
                                            <option [ngValue]="null"></option>
                                            <option *ngFor="let f of fields" [ngValue]="f">{{f.label}}</option>
                                        </select>
                                    </th>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let r of csv;let i=index">
                                        <td class="text-gray text-xs text-center" title="numero di riga">{{i+1}}</td>
                                        <td *ngFor="let c of r;let j=index" title="{{headers[j].name}}">{{c}}</td>
                                    </tr>
                                </tbody> -->

                                <thead>
                                    <!-- <th></th> -->
                                    <th>Data Contabile</th>
                                    <th>Data Valuta</th>
                                    <th>Descrizione</th>
                                    <th>Causale</th>
                                    <th>Importo</th>
                                </thead>
                                <thead>
                                    <!-- <th></th> -->
                                    <th>
                                        <select class="form-control form-control-sm">
                                            <option [ngValue]="Data">Data</option>
                                            <option [ngValue]="Descrizione">Descrizione</option>
                                            <option [ngValue]="Ingresso">Ingresso</option>
                                            <option [ngValue]="Uscita">Uscita</option>
                                            <option [ngValue]="Ingresso/Uscita">Ingresso/Uscita</option>
                                        </select>
                                    </th>
                                    <th>
                                        <select class="form-control form-control-sm">
                                            <option [ngValue]="Data">Data</option>
                                            <option [ngValue]="Descrizione">Descrizione</option>
                                            <option [ngValue]="Ingresso">Ingresso</option>
                                            <option [ngValue]="Uscita">Uscita</option>
                                            <option [ngValue]="Ingresso/Uscita">Ingresso/Uscita</option>
                                        </select>
                                    </th>
                                    <th>
                                        <select class="form-control form-control-sm">
                                            <option [ngValue]="Data">Data</option>
                                            <option [ngValue]="Descrizione">Descrizione</option>
                                            <option [ngValue]="Ingresso">Ingresso</option>
                                            <option [ngValue]="Uscita">Uscita</option>
                                            <option [ngValue]="Ingresso/Uscita">Ingresso/Uscita</option>
                                        </select>
                                    </th>
                                    <th>
                                        <select class="form-control form-control-sm">
                                            <option [ngValue]="Data">Data</option>
                                            <option [ngValue]="Descrizione">Descrizione</option>
                                            <option [ngValue]="Ingresso">Ingresso</option>
                                            <option [ngValue]="Uscita">Uscita</option>
                                            <option [ngValue]="Ingresso/Uscita">Ingresso/Uscita</option>
                                        </select>
                                    </th>
                                     <th>
                                        <select class="form-control form-control-sm">
                                            <option [ngValue]="Data">Data</option>
                                            <option [ngValue]="Descrizione">Descrizione</option>
                                            <option [ngValue]="Ingresso">Ingresso</option>
                                            <option [ngValue]="Uscita">Uscita</option>
                                            <option [ngValue]="Ingresso/Uscita">Ingresso/Uscita</option>
                                        </select>
                                    </th>
                                    <th>DOCUMENTO</th>
                                    <th>MOVIMENTO</th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <!-- <td><input type="checkbox" /></td> -->
                                        <td>12/07/2026</td>
                                        <td>13/07/2026</td>
                                        <td>sdjkHDKJbdkjghjd Amazon hjhga</td>
                                        <td>CM</td>
                                        <td>150,00 €</td>
                                        <td>
                                            <div class="btn-group btn-group-sm">
                                                <button class="btn btn-sm btn-default d-flex align-items-center">
                                                    <i class="fas fa-2x fa-check-circle text-success mr-1"></i>
                                                    <div class="d-inline-block text-left">
                                                        n. 12 del 30/12/2024<br>
                                                        Amazon Company<br>
                                                        150,00 €        
                                                    </div>
                                                </button>
                                                <button class="btn btn-sm btn-default" title="Vedi/Modifica"><i class="fas fa-pencil-alt"></i></button>
                                                <button class="btn btn-sm btn-default" title="Rimuovi"><i class="fas fa-times text-danger"></i></button>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="btn-group btn-group-sm">
                                                <button class="btn btn-sm btn-default d-flex align-items-center">
                                                    <i class="far fa-2x fa-check-circle text-gray mr-1"></i>
                                                    <div class="d-inline-block text-left">
                                                        30/12/2024<br>
                                                        Amazon Company<br>
                                                        150,00 €        
                                                    </div>
                                                </button>
                                                <button class="btn btn-sm btn-default" title="Vedi/Modifica"><i class="fas fa-pencil-alt"></i></button>
                                                <button class="btn btn-sm btn-default" title="Rimuovi"><i class="fas fa-times text-danger"></i></button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <!-- <td><input type="checkbox" /></td> -->
                                        <td>14/07/2026</td>
                                        <td>13/07/2026</td>
                                        <td>                                            
                                            sdjkHDKbdkjghjdhjh dgfgdfgsdfbdkjghjdhjh dgfgdfgsdfJbbdkjghjdhjh dgfgdfgsdfbdbdkjghjdhjh dgfgdfgsdfkjghjdhjh 
                                            dgfgdfgsdfdkjghjdhjh dgfgdfgsdfga bdkjghjdhjh dgfgdfgsdf
                                            <i class="fa fa-user text-gray ml-1 pointer" title="Associa anagrafica con stringa chiave"></i>
                                        </td>
                                        <td>CM</td>
                                        <td>150,00 €</td>
                                        <td>
                                            <div class="btn-group btn-group-sm">
                                                <button class="btn btn-sm btn-default d-flex align-items-center">
                                                    <i class="fa fa-2x fa-plus-circle text-gray mr-1"></i>
                                                    <div class="d-inline-block text-left">
                                                        crea
                                                    </div>
                                                </button>
                                                <button class="btn btn-sm btn-default d-flex align-items-center">
                                                    <i class="far fa-2x fa-arrow-alt-circle-right text-gray mr-1"></i>
                                                    <div class="d-inline-block text-left">
                                                        associa
                                                    </div>
                                                </button>
                                            </div>
                                        </td>
                                       <td>
                                            <div class="btn-group btn-group-sm">
                                                <button class="btn btn-sm btn-default d-flex align-items-center">
                                                    <i class="fa fa-2x fa-plus-circle text-gray mr-1"></i>
                                                    <div class="d-inline-block text-left">
                                                        crea
                                                    </div>
                                                </button>
                                                <button class="btn btn-sm btn-default d-flex align-items-center">
                                                    <i class="far fa-2x fa-arrow-alt-circle-right text-gray mr-1"></i>
                                                    <div class="d-inline-block text-left">
                                                        associa
                                                    </div>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                            </table>
                        </div>
                        <button class="btn btn-outline-secondary mr-2" (click)="reset()"><i class="fa fa-chevron-left mr-2"></i>Scegli un'altro file</button>
                        <button class="btn btn-outline-primary" (click)="startImport()">Avvia Riconciliazione</button>
                    </div>
            <!-- </ng-container> -->
        </div>        
    </div>
</ng-template>